import { render, staticRenderFns } from "./MajorMedicalInsuranceTableList.vue?vue&type=template&id=3c50268b&scoped=true&"
import script from "./MajorMedicalInsuranceTableList.vue?vue&type=script&lang=js&"
export * from "./MajorMedicalInsuranceTableList.vue?vue&type=script&lang=js&"
import style0 from "./MajorMedicalInsuranceTableList.vue?vue&type=style&index=0&id=3c50268b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50268b",
  null
  
)

export default component.exports